// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"6562cc91","749":"64929603"}[chunkId] + ".chunk.js";
};